<template>
  <div class="d-flex h-100">
    <div class="flex-grow-1">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-md-5">
            <div style="margin-top: 80px">
              <div class="text-center w-100">
                <img class="mb-4" width="150px" :src="baseUrl + 'img/logo_light.svg'" />
              </div>
              <h4 class="text-center text-muted mb-4">Bem vindo de volta!</h4>

              <div class="row">
                <div class="col-md-12">
                  <text-input @keyup.enter.native="submit" v-model="form.email.value" placeholder="exemplo@exemplo.com"
                    :name="'email'" :form="form" :alias="form.email.alias"></text-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <password-input @keyup.enter.native="submit" v-model="form.password.value" placeholder="Sua Senha"
                    :name="'password'" :form="form" :alias="form.password.alias"></password-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <b-form-checkbox switch size="sm" v-model="form.remember_me.value" :value="1"
                    :unchecked-value="0">Mantenha-me conectado</b-form-checkbox>
                </div>
              </div>
              <br />
              <error-handler :error="error" />

              <b-alert :show="alertData.isVisible" fade variant="danger">{{
                alertData.message
                }}</b-alert>
              <div class="text-center">
                <div class="form-group">
                  <button class="btn btn-primary px-5" @click="submit">
                    Login
                  </button>
                </div>
              </div>
              <hr class="mt-5" />
              <div class="text-center">
                <div>
                  Não possui conta?
                  <button class="btn btn-link text-info px-0" @click="redirect()">
                    Experimente grátis
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-md-block d-none w-50" style="background-color: #eaeefa">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-md-12 text-center">
            <div style="margin-top: 100px">
              <h4 class="mb-4 text-muted">Gerencie sua empresa de forma simples!</h4>
              <img class="mb-4" width="500px" :src="baseUrl + 'img/apex_1.png'" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <section class="h-100">
    </section> -->
  </div>
</template>

<script>
import Form from "./../mixins/Form.js";

export default {
  data() {
    return {
      form: new Form({
        email: {
          alias: "Email",
          validate: { required: true },
        },

        password: {
          validate: { required: true },
          alias: "Senha",
        },
        remember_me: {},
      }),

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },
  },

  methods: {
    // submit form
    submit() {
      this.resetErrors();
      if (this.form.isValid()) {
        this.makeLoginRequest();
      } else {
        this.setFormError();
      }
    },

    // make login request
    async makeLoginRequest() {
      this.$store.commit("showLoading");

      await this.$store
        .dispatch("auth/login", this.form.getValues())
        .then((response) => {
          this.$router.push("/pessoas");
        })
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },

    // set erros from form
    setFormError() {
      this.alertData.message = this.form.getFirstErrorMsg();
      this.alertData.isVisible = true;
    },

    redirect() {
      window.location.href = "https://sistema.apexcomercio.app/criar-conta?apexerp";
    },

    // reset errors
    resetErrors() {
      this.error = null;
      this.alertData.isVisible = false;
    },
  },
};
</script>
